import React, {Component} from 'react';
import { ServiceCollectionParam } from "../comp/ServiceCollection";
import CodeSnippet from "./CodeSnippet";
import { CodeSnippetApiDto } from "../common/dto/CodeSnippetApiDto";

type State = { snippets: CodeSnippetApiDto[] }
type Props = { username: string, tag: string }

export default class CommentListPage extends Component<ServiceCollectionParam & Props, {}> {

    state: State = {
        snippets: []
    }

    async componentDidMount() {
        const snippets = await this.props.services.dao
            .findReviewCodeSnippetsForUserTag(this.props.username, this.props.tag);

        this.state.snippets = snippets;

        this.setState(this.state);
    }

    render() {

        let c = 0;

        return (
            <>
                { this.state.snippets.map(each =>
                    <CodeSnippet key={c++} snippet={ each } />) }
            </>);
    }

}

